export default {
  farmer: '/farmer',
  farmerPersonalInformation: '/farmer-personal-information',
  farmerFamilyInformation: '/farmer-family-information',
  farmerFarmsInformation: '/farmer-farms-information',
  farmerCropsInformation: '/farmer-crops-information',
  farmerAnimalHusbandryInformation: '/farmer-animal-husbandry-information',
}
